import fetchCCAResults from './fetchCCAResults';

export default [
  fetchCCAResults,
];
